export const notifySuccess = (dispatch, msg) => {
  dispatch({
    type: 'notification',
    data: { notification_type: 'success', msg },
  })
}

export const notifyError = (dispatch, msg) => {
  dispatch({
    type: 'notification',
    data: { notification_type: 'error', msg },
  })
}
